/**
 * Keyboard focus ring drawn inside the element. Use on full-bleed rows inside
 * `overflow-hidden` containers (accordion headers, list rows), where the global
 * offset ring from `index.css` would be clipped.
 */
export const focusRingInsetClass =
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary-500 focus-visible:ring-offset-0";
